import {
    Card,
    type CardProps,
    Container,
    type ContainerProps,
    Grid,
    type GridProps,
} from "@octopus-energy/coral/atoms"
import { mergeResponsiveProps } from "@oefr/ui"

type DashboardLayoutCardProps = GridProps & {
    cardProps?: CardProps
    containerProps?: ContainerProps
    wrapperContainerProps?: ContainerProps
}

const DEFAULT_CARD_PROPS: CardProps = {
    borderless: true,
    padding: "none",
}

const DEFAULT_CONTAINER_PROPS: ContainerProps = {
    fullHeight: true,
    paddingY: "lg",
    paddingX: { md: "lg" },
}

const DEFAULT_WRAPPER_CONTAINER_PROPS: ContainerProps = {
    fullHeight: true,
    theme: { base: "base900", md: "none" },
    paddingX: { base: "sm", md: "none" },
}

const DEFAULT_GRID_PROPS: GridProps = {
    gap: "lg",
    fullHeight: true,
    gridTemplateColumns: "100%",
}

export function DashboardLayoutCard({
    cardProps,
    containerProps,
    wrapperContainerProps,
    ...props
}: DashboardLayoutCardProps) {
    const mergedCardProps = mergeResponsiveProps(DEFAULT_CARD_PROPS, cardProps)
    const mergedContainerProps = mergeResponsiveProps(DEFAULT_CONTAINER_PROPS, containerProps)
    const mergedWrapperContainerProps = mergeResponsiveProps(
        DEFAULT_WRAPPER_CONTAINER_PROPS,
        wrapperContainerProps
    )
    const mergedGridProps = mergeResponsiveProps(DEFAULT_GRID_PROPS, props)

    return (
        <Container {...mergedWrapperContainerProps}>
            <Card {...mergedCardProps}>
                <Container {...mergedContainerProps}>
                    <Grid {...mergedGridProps} />
                </Container>
            </Card>
        </Container>
    )
}
